export class BestandMetadataDto {
  readonly hasPreview!: boolean;
  readonly name!: string;
  readonly size!: number;
}
